
/* injects from baggage-loader */
require('./wish-list-distr-list.component.html');

